
// For now these are just static in the frontend - but later when we need to, we can move these to the backend
// and make the api codegen create these
export namespace productRegions {
    export const DEV_REGION_NAME = 'Dev';
    export const QA_REGION_NAME = 'QA';
    export const SANDBOX_REGION_NAME = 'Sandbox';
    export const NEW_ZEALAND_REGION_NAME = 'NewZealand';
    export const AUSTRALIA_REGION_NAME = 'Australia';
    export const NORTH_AMERICA_REGION_NAME = 'NorthAmerica';
    export const UNITED_KINGDOM_REGION_NAME = 'UnitedKingdom';
}
